import LogIn from './Pages/Login/LogIn'
import Dashboard from './Pages/Dashboard/Dashboard'
import Invoice from './Pages/Invoices/Invoice';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Messages from "./Pages/Messages/Messages";
import Transaction from "./Pages/Transaction/Transaction";
import ShareHolders from "./Pages/Shareholders/ShareHolders";
import Spends from "./Pages/Spends/Spends";
import Clients from "./Pages/Clients/Clients";
import Employees from './Pages/Employees/Employees';
import AddUpdateInvoice from './Pages/Invoices/AddUpdateInvoice';
import ViewInvoice from './Pages/Invoices/ViewInvoice';
import ViewClient from './Pages/Clients/ViewClient'
import ShareDistribution from './Pages/Transaction/ShareDistribution';
import ViewTransaction from './Pages/Transaction/ViewTransaction'
import ViewEmployee from './Pages/Employees/ViewEmployee'
import PrivateRoute from './Components/PrivateRoute';
import PublicRoute from './Components/PublicRoute';
import Home from './Components/Home';
import ViewShareHolder from './Pages/Shareholders/ViewShareHolder';
import ViewSpends from './Pages/Spends/ViewSpends';
import AddUpdateTransaction from './Pages/Transaction/AddUpdateTransaction';
import AddUpdateShareHolder from './Pages/Shareholders/AddUpdateShareHolder';
import AddUpdateEmployee from './Pages/Employees/AddUpdateEmployee';
import AddUpdateClient from './Pages/Clients/AddUpdateClient'
import ShareHoldersGroup from './Pages/Shareholders/ShareHoldersGroup';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ViewShareHoldersGroup from './Pages/Shareholders/ViewShareHoldersGroup';
import AddUpdateShareHolderGroup from './Pages/Shareholders/AddUpdateShareHolderGroup';

function App() {

  return (
    <BrowserRouter>
      <ToastContainer hideProgressBar={true} />
      <Routes>
        <Route path='/' element={<PublicRoute element={<Home />} />} />
        <Route path='/login' element={<PublicRoute element={<LogIn />} />} />
        <Route path="/dashboard" element={<PrivateRoute element={<Dashboard />} />} />  
        <Route path='/invoice' element={<PrivateRoute element={<Invoice />} />} />
        <Route path='/messages' element={<PrivateRoute element={<Messages />} />} />
        <Route path='/transaction' element={<PrivateRoute element={<Transaction />} />} />
        <Route path='/shareholder' element={<PrivateRoute element={<ShareHolders />} />} />
        <Route path='/shareholder/group' element={<PrivateRoute element={<ShareHoldersGroup />} />} />
        <Route path='/spends' element={<PrivateRoute element={<Spends />} />} />
        <Route path='/clients' element={<PrivateRoute element={<Clients />} />} />
        <Route path='/employees' element={<PrivateRoute element={<Employees />} />} />
        <Route path='/invoice/add' element={<PrivateRoute element={<AddUpdateInvoice />} />} />
        <Route path='/invoice/edit' element={<PrivateRoute element={<AddUpdateInvoice />} />} />
        <Route path='/invoice/view' element={<PrivateRoute element={<ViewInvoice />} />} />
        <Route path='/clients/add' element={<PrivateRoute element={<AddUpdateClient />} />} />
        <Route path='/clients/edit' element={<PrivateRoute element={<AddUpdateClient />} />} />
        <Route path='/clients/view' element={<PrivateRoute element={<ViewClient />} />} />
        <Route path='/transaction/add' element={<PrivateRoute element={<AddUpdateTransaction />} />} />
        <Route path='/transaction/edit' element={<PrivateRoute element={<AddUpdateTransaction />} />} />
        <Route path='/transaction/view' element={<PrivateRoute element={<ViewTransaction />} />} />
        <Route path='/transaction/ShareDistribution' element={<PrivateRoute element={<ShareDistribution />} />} />
        <Route path='/employee/edit' element={<PrivateRoute element={<AddUpdateEmployee />} />} />
        <Route path='/employee/view' element={<PrivateRoute element={<ViewEmployee />} />} />
        <Route path='/shareholder/add' element={<PrivateRoute element={<AddUpdateShareHolder />} />} />
        <Route path='/shareholder/group/add' element={<PrivateRoute element={<AddUpdateShareHolderGroup />} />} />
        <Route path='/shareholder/edit' element={<PrivateRoute element={<AddUpdateShareHolder />} />} />
        <Route path='/shareholder/group/edit' element={<PrivateRoute element={<AddUpdateShareHolderGroup />} />} />
        <Route path='/shareholder/view' element={<PrivateRoute element={<ViewShareHolder />} />} />
        <Route path='/shareholder/group/view' element={<PrivateRoute element={<ViewShareHoldersGroup />} />} />
        <Route path='/spends/view' element={<PrivateRoute element={<ViewSpends />} />} />
      </Routes>
    </BrowserRouter>
  )
}

export default (App);
